import { axiosRequest } from './../../service/axios';

export const getList = (params) => {
  const url = 'users/list';
  const options = {
    method: 'get',
  };
  const axiosData = {
    url,
    params,
    options,
  };
  return axiosRequest(axiosData);
};

export const userLock = (id) => {
  const url = `users/lock/${id}`;
  const axiosData = {
    url,
  };
  return axiosRequest(axiosData);
};

export const userActivate = (id) => {
  const url = `users/activate/${id}`;
  const axiosData = {
    url,
  };
  return axiosRequest(axiosData);
};

export const getSingleUser = (id) => {
  const url = `users/show/${id}`;
  const options = {
    method: 'get',
  };
  const axiosData = {
    url,
    options,
  };
  return axiosRequest(axiosData);
};

export const getDeleteUserForm = (id) => {
  const options = {
    method: 'get',
  };
  const url = `users/delete-form-data/${id}`;
  const axiosData = {
    url,
    options,
  };
  return axiosRequest(axiosData);
};

export const deleteUser = (id, data) => {
  const url = `users/delete/${id}`;
  const axiosData = {
    url,
    data,
  };
  return axiosRequest(axiosData);
};


export const getAddFormData = () => {
  const url = 'users/create-form-data';
  const options = {
    method: 'get',
  };
  const axiosData = {
    url,
    options,
  };
  return axiosRequest(axiosData);
};

export const getEditFormData = (id) => {
  const url = `users/edit-form-data/${id}`;
  const options = {
    method: 'get',
  };
  const axiosData = {
    url,
    options,
  };
  return axiosRequest(axiosData);
};


export const storeUser = (data) => {
  const url = 'users/store';
  const axiosData = {
    url,
    data,
  };
  return axiosRequest(axiosData);
};


export const updateUser = (id, data) => {
  const url = `users/update/${id}`;
  const axiosData = {
    url,
    data,
  };
  return axiosRequest(axiosData);
};

export const getUserFilterList = (params) => {
  const url = 'users/filter-list';
  const options = {
    method: 'get',
  };
  const axiosData = {
    url,
    options,
    params,
  };
  return axiosRequest(axiosData);
};

export const getEmailFilterList = (params) => {
  const url = 'users/email-filter-list';
  const options = {
    method: 'get',
  };
  const axiosData = {
    url,
    options,
    params,
  };
  return axiosRequest(axiosData);
};

export const accessManage = (id) => {
  const url = `users/access-manage/${id}`;
  const options = {
    method: 'get',
  };
  const axiosData = {
    url,
    options,
  };
  return axiosRequest(axiosData);
};

export const storeAccessManage = (id, data) => {
  const url = `users/access-manage/${id}`;
  const axiosData = {
    url,
    data,
  };
  return axiosRequest(axiosData);
};

export const storeProfile = (data) => {
  const url = 'users/profile';
  const axiosData = {
    url,
    data,
  };
  return axiosRequest(axiosData);
};

export const userProfile = () => {
  const url = 'users/profile';
  const options = {
    method: 'get',
  };
  const axiosData = {
    url,
    options,
  };
  return axiosRequest(axiosData);
};

